import {createSelector} from "reselect"
import {getReport} from "../../report"
import initialState from "./initialState"

// Database constants
const SUMMARY = "Summary"

// SELECTORS
export const getReportTemplates = (state) => getReport(state).templates

// 1
export const getReportSummaryTemplate = createSelector(
  getReportTemplates,
  (templates) => templates.find((template) => template.name === SUMMARY)
)

// REDUCER
export default (state = initialState, action) => state
